import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import UserAvatarEleg from '../../components/UserAvatarEleg';
import services from '../../services/services';
import Loader from 'react-loader-spinner';
import { ToastContainer } from 'react-toastify';
import Button from '@material-ui/core/Button';
import { allNotifications } from '../../utils/toastify';
import { MiniLoader } from '../../components/Loader';

import './index.scss';

const { notifyErrorBottomRight } = allNotifications;

const styles = {
  CheckElegibility: {
    padding: '5px 15px 0 15px',
    maxWidth: 415,
    margin: '-4% auto'
  }
};

class Elegibility extends Component {
  state = {
    codbenef: '',
    loading: false,
    description: '',
    isFocused: false,
    procedureId: '',
    proceduresList: [],
    procedureLabelClassName: ''
  };

  checkPatient = async () => {
    if (!this.state.codbenef) {
      this.notify('Para verificar a elegibilidade, por favor, digite o número da carteirinha do beneficiário.');
      return;
    }

    this.setState({ loading: !this.state.loading });
    services
      .beneficiario('getContractNumber', this.state.codbenef)
      .then(responseContrato => {
        const { codBenef, nomeBenef, registroANS } = responseContrato;

        services
          .beneficiario('getElegibility', {
            codBenef: this.state.codbenef,
            contrato: responseContrato.contrato,
            codPrest: localStorage.getItem('codDentista'),
            codServico: this.state?.procedureId
          })
          .then(response => {
            const { flagElegivel, msgRetorno, cobertura = response.coberturaProcedimento?.cobertura , carencia =  response.coberturaProcedimento?.carencia } = response;

            const dadosBenef = {
              codBenef,
              nomeBenef,
              flagElegivel,
              registroANS,
              codServico: this.state?.procedureId,
              cobertura,
              carencia,
              msgRetorno
            };

            this.props.history.push({ pathname: '/elegivel', state: dadosBenef });
          })
          .catch(err => {
            this.notify(err.message);
          });
      })
      .catch(err => {
        this.notify(err.message);
      })
      .finally(() => {
        this.setState({ loading: !this.state.loading });
      });
  };

  notify = message => notifyErrorBottomRight(message);

  loadProcedures = value =>
    services
      .procedimento('getProceduresTypesWithToken', value)
      .then(res => this.setState({ proceduresList: res, showProcedureError: false }))
      .catch(() => {
        this.setState({ showProcedureError: true, proceduresList: [] });
      })
      .then(() => this.setState({ isLoadingProcedures: false }))

  handleInputProcedures = e => {
    const limitToSearch = 5;
    const { value } = e.target;

    const isSmaller = value.length < limitToSearch;
    const hasValue = value.length > 0

    this.setState({ procedureLabelClassName: hasValue ? 'active' : '' });

    this.setState({ showProcedureError: false });

    this.setState(
      {
        description: value,
        isLoadingProcedures: !isSmaller
      },
      () => {
        if (isSmaller) {
          this.setState({ proceduresList: [] });
        } else {
          // Caso seja número deve trazer tudo para depois filtrar a lista
          if (Number.isNaN(value)) {
            this.loadProcedures(value);
          } else {
            this.loadProcedures();
          }

          this.setState({ isFocused: !!this.state.description.length });
        }
      }
    );
  };

  handleBlur = () => setTimeout(() => this.setState({ isFocused: false }), 700);

  onSelectProcedure = async value => {
    this.setState({ showOverlayLoading: true });

    this.setState(
      {
        description: value.descricao,
        selectedProcedure: value,
        isFocused: false,
        faceDisable: true,
        procedureId: value.codigo.trim(),
        showProcedureError: false,
        showOverlayLoading: false
      }
    );
  };

  render() {
    const { primeiroNome, codigo, name, procedure } = this.props;
    const { loading, isFocused, description, proceduresList, procedureLabelClassName } = this.state;

    return (
      <Fragment>
        <ToastContainer />
        <Header class="title-center orange-gradient" name="Elegibilidade" />

        <div className="CheckElegibility" style={styles.CheckElegibility}>

          <div className="row" style={{ marginTop: '4rem' }}>
            <UserAvatarEleg bgClass="UserAvatar" />
          </div>

          <div className="label">
            <p className="paragraph-blue">
              Para verificar a elegibilidade, insira o número da carteirinha do beneficiário no campo abaixo:
            </p>
          </div>

          <div className="row" style={{ marginTop: '4rem' }}>
            <form>
              <div className="input-field">
                <input
                  id="pacient_ci"
                  type="text"
                  maxLength="18"
                  pattern="[0-9]*"
                  value={this.state.codbenef}
                  onChange={event =>
                    this.setState({ codbenef: event.target.value.replace(/\D/, '') })
                  }
                />
                <label htmlFor="pacient_ci" className="active">Digite o número da carteirinha</label>
              </div>

              {/** INPUT DE PROCEDIMENTOS */}
              <div className="input-field">
                <input
                  type="text"
                  id="input_proc"
                  autoComplete="off"
                  value={procedure ? procedure.descricao : description}
                  className="autocomplete"
                  onBlur={this.handleBlur}
                  onChange={this.handleInputProcedures}
                  disabled={!!procedure}
                />
                <label className={procedureLabelClassName} htmlFor="input_proc">
                  Procedimentos
                </label>
                <ul
                  className="autocomplete-content dropdown-content"
                  style={isFocused ? { display: 'block' } : { display: 'none' }}
                >
                  {!this.state.isLoadingProcedures &&
                    proceduresList
                      .filter(
                        item =>
                          item.descricao.toUpperCase().indexOf(description.toUpperCase()) !== -1
                      )
                      .map(item => (
                        <li key={item.codigo} onClick={() => this.onSelectProcedure(item)}>
                          <span>{item.descricao}</span>
                        </li>
                      ))}
                  {this.state.isLoadingProcedures && (
                    <li className="listLoader">
                      <MiniLoader />
                    </li>
                  )}
                </ul>
              </div>

              <div className="btn-enviar">
                <Button
                  variant="contained"
                  disableElevation
                  onClick={this.checkPatient}
                  disabled={loading}
                >
                  {loading ? (
                    <div style={{ marginTop: 4 }}>
                      <Loader type="Ball-Triangle" color="#00BFFF" height="20" width="20" />
                    </div>
                  ) : (
                    'Verificar'
                  )}
                </Button>
              </div>
            </form>
          </div>
        </div>

      </Fragment>
    );

  }
}

Elegibility.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired
};

export default Elegibility;